module.exports = __webpack_public_path__ + "static/scale-model-of-abandoned-school-in-abilene-texas-35285029a448a01ee90a93e9e7cc7030.png";